/** Rounds to cents, keeping repeated additions from drifting. */
export const round2 = (amount: number): number =>
  parseFloat((Math.round((amount + Number.EPSILON) * 100) / 100).toFixed(2));

/** USD for display. Strings are parsed; anything unusable renders as a dash. */
export const formatCurrency = (amount: number | string | null | undefined): string => {
  const value = typeof amount === 'string' ? parseFloat(amount) : amount;
  if (value === null || value === undefined || isNaN(value)) return '—';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);
};
